export interface AppInsightsConfig {
  connectionString: string;
}

export function appInsightsConfigHasRequiredFields(config: AppInsightsConfig): boolean {
  return !!config?.connectionString;
}
